import Dashboard from "../../components/dashboard/DashBoard"

function DashBoardPage() {
    return (
        <>
       <Dashboard/>
        </>
    )
}
export default DashBoardPage